import { initMap } from '../components/CommunityMap';
import { initDesignPhotoSlideShows } from '../components/DesignPhotoSlideshow';
import QuickViewDesignModal from '../components/QuickViewDesignModal';

document.addEventListener('DOMContentLoaded', () => {
  initDesignPhotoSlideShows();

    const quickviewModal = QuickViewDesignModal('js-quickview-modal');
  const quickviewBtns = document.querySelectorAll('.js-btn-quickview');
  quickviewBtns.forEach(quickviewBtn => {
    quickviewBtn.addEventListener('click', event => {
      event.preventDefault();
        const target = event.target as HTMLElement;
        const dataId = target.dataset.id;

        if (dataId) {
            // Now you have the data-id value, you can pass it to your function
            quickviewModal.open(Number(dataId));
        }
    });
  });
});

window.addEventListener('load', () => {
  //initialize map
  initMap('js-community-map-info-window').catch(error => {
    console.error('Failed to initialize map:', error);
  });
});
